import { useEffect } from "react";

import Login from "./components/Login.jsx";
import Navbar from "./components/Navbar.jsx";
import Register from "./components/Register.jsx";
import ForgotPassword from "./components/ForgotPassword.jsx";
import ResetPassword from "./components/ResetPassword.jsx";
import Footer from "./components/Footer.jsx";

import AddAppointment from "./pages/AddAppointment.jsx";
import AddDoctor from "./pages/AddDoctor.jsx";
import Home from "./pages/Home.jsx";
import MyAppointments from "./pages/MyAppointments.jsx";
import AllDoctors from "./pages/AllDoctors.jsx";
import DoctorDetails from "./pages/DoctorDetails.jsx";
import AddDepartment from "./pages/AddDepartment";
import EditDoctor from "./pages/EditDoctor.jsx";
import AdminAppointments from "./pages/AdminAppointments.jsx";
import DoctorAppointments from "./pages/DoctorAppointments.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import DoctorProfile from "./pages/DoctorProfile.jsx";

import RoleBasedRoute from "./components/RoleBasedRoute.jsx";

import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "./context/ThemeContext";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}

function App() {
  const { theme } = useTheme();
  const location = useLocation();

  const hideFooterRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/admin/dashboard",
    "/admin/appointments",
    "/add-doctor",
    "/add-department",
    "/doctor/dashboard",
    "/doctor/appointments",
    "/doctor/profile",
  ];

  const shouldHideFooter =
    hideFooterRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/reset-password") ||
    location.pathname.startsWith("/edit-doctor");

  return (
    <div className="flex min-h-screen w-full max-w-full flex-col bg-[var(--app-bg)] text-[var(--app-text)] transition-colors duration-300">
      <ScrollToTop />
      <Navbar />

      <div className="min-w-0 flex-1">
        <Routes>
          <Route path="/" element={<Home />} />

          {/* Auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Patient routes */}
          <Route path="/add-appointment" element={<AddAppointment />} />
          <Route path="/my-appointments" element={<MyAppointments />} />

          {/* Public doctor routes */}
          <Route path="/allDoctors" element={<AllDoctors />} />
          <Route path="/doctor/:id" element={<DoctorDetails />} />

          {/* Admin routes */}
          <Route
            path="/add-doctor"
            element={
              <RoleBasedRoute element={<AddDoctor />} requiredRole="admin" />
            }
          />

          <Route
            path="/admin/dashboard"
            element={
              <RoleBasedRoute
                element={<AdminDashboard />}
                requiredRole="admin"
              />
            }
          />

          <Route
            path="/admin/appointments"
            element={
              <RoleBasedRoute
                element={<AdminAppointments />}
                requiredRole="admin"
              />
            }
          />

          <Route
            path="/edit-doctor/:id"
            element={
              <RoleBasedRoute element={<EditDoctor />} requiredRole="admin" />
            }
          />

          <Route
            path="/add-department"
            element={
              <RoleBasedRoute
                element={<AddDepartment />}
                requiredRole="admin"
              />
            }
          />

          {/* Doctor routes */}
          <Route
            path="/doctor/dashboard"
            element={
              <RoleBasedRoute
                element={<DoctorAppointments />}
                requiredRole="doctor"
              />
            }
          />

          <Route
            path="/doctor/appointments"
            element={
              <RoleBasedRoute
                element={<DoctorAppointments />}
                requiredRole="doctor"
              />
            }
          />

          <Route
            path="/doctor/profile"
            element={
              <RoleBasedRoute
                element={<DoctorProfile />}
                requiredRole="doctor"
              />
            }
          />
        </Routes>
      </div>

      {!shouldHideFooter && <Footer />}

      <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme === "dark" ? "dark" : "colored"}
      />
    </div>
  );
}

export default App;